import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import im from "./modules/im";
import permission from './modules/permission'
import product from './modules/product'
import pageCache from './modules/pageCache'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    im,
    permission,
    product,
    pageCache
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js